<template>
<div>
  <router-view></router-view>


  <p class = "title is-1 title-font section"> Trabajos </p>
  <div class = "columns section is-multiline is-centered">
    <div class = "column is-one-third" v-for = "image in imageList" :key = "image.id" >
      <div class = "title is-2 title-font"> {{image.name}} </div>
      <div class = "box" @click="jumpTo(image.name)">
        <figure class="image is-4by3">
          <img :src="image.pic">
        </figure>
      </div>
    </div>
    
  </div>
</div>
</template>

<script>
import {requester} from '../App.vue';

export default {
  name: 'GalleryList',
  data() {
    return { 
      imageList: [
        {
          id: 1,
          name: "Toldo Brazo Stor",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 2,
          name: "Toldo Brazo Recto",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 3,
          name: "Toldo Brazo Articulado",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 4,
          name: "Toldo Capota",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 5,
          name: "Toldo Vertical",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 6,
          name: "Toldo Vela o Plano",
          pic: require("../../public/fotos/placeholder.png")
        },
        {
          id: 7,
          name: "Toldo Piscina",
          pic: require("../../public/fotos/placeholder.png")
        }
      ],
    }
  },
  methods: {
    jumpTo: function(type){
      this.$router.push({name: "GalleryDetail", params: {id: type}})
    },
    hasType: function(type){
      for (let i = 0; i< this.imageList.length; i++){
        let image = this.imageList[i];
        if(image.name == type){
          return i;
        }
      }
      return null;
    }
  },
  mounted: function(){
      requester.get('gallery/',
      ).then((response) => {
        for (var i = 0; i < response.data.length; i++){
          var newPic = response.data[i];
          let imageIndex = this.hasType(newPic.type);
          this.imageList[imageIndex].pic = newPic.displayImage;
        }
      }).catch(() => {
        
      })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title-font {
  font-family: "Baloo Bhaina 2";
}
h1, h2 {
  font-weight: normal;
}
div {
  text-align: center;
}

</style>